"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const LabeledFieldWidget_1 = tslib_1.__importDefault(require("./LabeledFieldWidget"));
class LabeledTextAreaFieldWidget extends LabeledFieldWidget_1.default {
    constructor(args) {
        super({
            ...args,
            fieldType: "textarea"
        });
    }
    setValue(value, fireEvents = false) {
        super.setValue(value, fireEvents);
        if (this.characterLimitElement) {
            this.updateCharacterCountText();
        }
    }
    getFieldElement() {
        return super.getFieldElement();
    }
    /**
     * @deprecated Use getFieldElement() instead.
     */
    getInput() {
        return this.getFieldElement();
    }
    addKeyUpListener(listener) {
        this.fieldElement.addEventListener("keyup", listener);
    }
    addKeyDownListener(listener) {
        this.fieldElement.addEventListener("keydown", listener);
    }
    addKeyPressListener(listener) {
        this.fieldElement.addEventListener("keypress", listener);
    }
    addPasteListener(listener) {
        this.fieldElement.addEventListener("paste", listener);
    }
    setMaxLength(maxLength) {
        this.fieldElement.maxLength = maxLength;
        this.updateCharacterCountText();
    }
    setPlaceholder(value) {
        super.setPlaceholder(value);
        if (!value) {
            this.fieldElement.removeAttribute("placeholder");
        }
        else {
            this.fieldElement.setAttribute("placeholder", value);
        }
    }
    decorateLabeledFieldWidgetElement(args) {
        const { readOnly = false, placeholder = "", maxLength } = args;
        this.fieldElement.readOnly = readOnly;
        this.fieldElement.placeholder = placeholder;
        this.addOnFocusHandler(() => this.fieldElement.select());
        if (maxLength) {
            this.fieldElement.maxLength = maxLength;
            this.characterLimitElement = document.createElement("small");
            this.characterLimitElement.setAttribute("role", fmko_ts_common_1.ARIARole.COMMENT);
            this.characterLimitElement.setAttribute(fmko_ts_common_1.ARIA.LIVE, "polite");
            this.updateCharacterCountText();
            this.addKeyUpListener(() => this.updateCharacterCountText());
        }
        this.decorateLabeledTextAreaFieldWidgetElement(args);
    }
    updateCharacterCountText() {
        const maxLength = this.fieldElement.maxLength;
        const inputLength = this.fieldElement.value.length;
        this.characterLimitElement.textContent = `${inputLength} ud af ${maxLength} tegn`;
        if (inputLength === maxLength) {
            this.characterLimitElement.setAttribute(fmko_ts_common_1.ARIA.LIVE, "assertive");
        }
        else {
            this.characterLimitElement.removeAttribute(fmko_ts_common_1.ARIA.LIVE);
        }
    }
}
exports.default = LabeledTextAreaFieldWidget;
//# sourceMappingURL=LabeledTextAreaFieldWidget.js.map